import { render, staticRenderFns } from "./PrintClassListButton.vue?vue&type=template&id=67a95e5e&scoped=true"
import script from "./PrintClassListButton.vue?vue&type=script&lang=ts"
export * from "./PrintClassListButton.vue?vue&type=script&lang=ts"
import style0 from "./PrintClassListButton.vue?vue&type=style&index=0&id=67a95e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a95e5e",
  null
  
)

export default component.exports